
export const apiResponseWrapper = (res) => {

  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with res data
  if (res.isOk) {
    return res.data;
  } else {
    throw res.error.response.data;
  }
};
